// extracted by mini-css-extract-plugin
export var measureBox = "_ay-0";